import { render, staticRenderFns } from "./ProduccionV2.vue?vue&type=template&id=79876168&"
import script from "./ProduccionV2.vue?vue&type=script&lang=js&"
export * from "./ProduccionV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports